import { UIAjaxWrapper } from '../../../shared/scripts/network/UIAjaxWrapper.ts';
import { showSimpleDialog } from '../../../shared/scripts/ui_popup/showSimpleDialog.ts';
import { UIAPIEndpoints } from '../../../shared/scripts/network/UIAPIEndpoints.ts';
import { ClientUserState } from '../ClientUserState.ts';
export class UIStoreAjaxEndPoints {
    static async purchaseItem(item, onSuccess, onFailure) {
        const urlVariable = `${item.category}/${item.type}`;
        const response = await UIAjaxWrapper.postRequestHandler(`${UIAPIEndpoints.apiPayPurchaseItem()}/${urlVariable}`, undefined, undefined);
        if (response == undefined) throw new Error('Failed to purchase item');
        if (!response.isSuccess) return;
        const json = response.json;
        await ClientUserState.refresh();
        const title = json.status ? {
            key: 'strings:storePage.success.success'
        } : {
            key: 'strings:popups.errors.general.title'
        };
        if (json.status) {
            if (onSuccess) return onSuccess(json.message);
            return;
        }
        if (onFailure) return onFailure(json.message);
        return showSimpleDialog({
            title: title,
            body: json.message
        });
    }
    static async activateGiftedMembership(itemId) {
        const response = await UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.apiActivateGiftMembership(), undefined, {
            itemId: itemId
        });
        if (response == undefined) return;
        await ClientUserState.refresh();
        const title = {
            key: 'strings:storePage.success.success'
        };
        const body = {
            key: 'strings:storePage.sections.membership.activated'
        };
        return showSimpleDialog({
            title: title,
            body: body
        });
    }
    static async cancelGiftedMembership() {
        const response = await UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.apiCancelGiftMembership(), undefined, undefined);
        if (response == undefined) return;
        await ClientUserState.refresh();
    }
}
